// extracted by mini-css-extract-plugin
module.exports = {"panel":"Feedback_panel__4bv6z","imageDiv":"Feedback_imageDiv__3gnqU","rotating":"Feedback_rotating__UfkyD","rotatingAnim":"Feedback_rotatingAnim__2sOkA"};